module.exports = __webpack_public_path__ + "img/file-spreadsheet-blue.e56be436.svg";